import { ACTION } from './notification_actions';
import { update_reducer, list_reducer } from '../reducers';

const initialState = {
  objects: {},
  orderedIds: [],
  isLoading: false,
  isMarkingAsRead: false,
  errorMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        ...list_reducer(state, action),
        isLoading: false,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.READ}_PENDING`:
      return {
        ...state,
        isMarkingAsRead: true,
        errorMessage: null,
      };
    case `${ACTION.READ}_FULFILLED`:
      return {
        ...action.payload.data.reduce(
          (accState, item) => ({
            ...accState,
            ...update_reducer(accState, { payload: item }),
          }),
          state,
        ),
        isMarkingAsRead: false,
        errorMessage: null,
      };
    case `${ACTION.READ}_REJECTED`:
      return {
        ...state,
        isMarkingAsRead: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/notification/notification_reducer.js